import { useRef, useEffect } from 'react';
import { isDesktop } from 'shared/lib';
import {
	GAME_PAGE_LOGO_WIDTH_ASPECT,
	GAME_PAGE_LOGO_WIDTH,
	GAME_PAGE_LOGO_HEIGHT_ASPECT,
	GAME_PAGE_LOGO_HEIGHT,
} from '../config';

export const useScaleLogo = () => {
	const logoRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleResize = () => {
			if (logoRef.current === null) return;
			const width = document.documentElement.clientWidth;
			const height = document.documentElement.clientHeight;

			if (isDesktop(width, height)) {
				const scaleX = (GAME_PAGE_LOGO_WIDTH_ASPECT * width) / GAME_PAGE_LOGO_WIDTH;
				const scaleY = (GAME_PAGE_LOGO_HEIGHT_ASPECT * height) / GAME_PAGE_LOGO_HEIGHT;

				logoRef.current.style.scale = `${(scaleX + scaleY) / 2}`;

				return;
			}

			logoRef.current.style.scale = '1';
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return logoRef;
};
